import { atom } from 'jotai'

/**
 * 非表示車両管理モーダル (HiddenVehicleManageModal) の開閉状態（本件 #3456）。
 *
 * トリガー側 (features 配下、DispatchBoardPresetSelectBar 直下の「非表示車両の管理」独立ボタン) と
 * モーダル本体 (routes 配下の HiddenVehicleManageModal) が別レイヤに分かれているため
 * atom 経由で接続する (features → routes の import 禁忌の回避、PresetManageModal と同型)。
 */
export const hiddenVehicleManageOpenAtom = atom<boolean>(false)
